import { computed } from 'vue'
import type { Product } from '@scayle/storefront-nuxt'
import { useState } from '#app/composables/state'
import useProductBreadcrumbs from '#layers/base/composables/useProductBreadcrumbs'
import useCms from '~/composables/cms/useCms'
import { useCurrentShop } from '#storefront/composables'
// import useCms from './cms/useCms'
import { Locale } from '~/config/locales'
import type {
  SbContentPage,
  StoryblokStory,
} from '~/cms/storyblok/types/storyblok.d.ts'

const DEFAULT_PATHS: Record<Locale, string> = {
  [Locale.De]: '/c/service/groessentabellen/',
  [Locale.Ch]: '/c/service/groessentabellen/',
  [Locale.At]: '/c/service/groessentabellen/',
  [Locale.Nl]: '/c/service/onze-maattabellen/',
  [Locale.Be]: '/c/service/onze-maattabellen/',
  [Locale.FrBe]: '/c/service/nos-tableaux-de-tailles/',
  [Locale.FrCh]: '/c/service/nos-tableaux-de-tailles/',
  [Locale.Fr]: '/c/service/nos-tableaux-de-tailles/',
  [Locale.Fi]: '/c/service/kokotaulukko/',
}

const useProductSizeGuide = (product: Product) => {
  const sizeGuideState = useState<StoryblokStory<SbContentPage> | undefined>(
    `sizeGuide-${product.id}`,
    () => undefined,
  )

  const currentShop = useCurrentShop()
  const { data, fetchBySlug, fetching } = useCms<SbContentPage>(
    `size-guide-${currentShop.value.locale}`,
  )

  const { selectedCategoryPath } = useProductBreadcrumbs(product)

  const sizeGuidePath = computed(() => {
    // Walk the selected breadcrumb path bottom-up for a category-specific size
    // guide link, falling back to the locale default.
    const categorySizeGuide = [...selectedCategoryPath]
      .reverse()
      .find((node) =>
        Boolean(node.countryLevelCustomData?.cmsPagePath_PDP_sizeGuideLink),
      )

    return (
      (categorySizeGuide?.countryLevelCustomData
        ?.cmsPagePath_PDP_sizeGuideLink as string | undefined) ||
      DEFAULT_PATHS[currentShop.value.locale as Locale]
    )
  })

  const getSizeGuide = async () => {
    await fetchBySlug(sizeGuidePath.value)

    sizeGuideState.value = data.value
  }

  return {
    getSizeGuide,
    sizeGuide: computed(() => sizeGuideState.value?.content?.content),
    fetching,
  }
}

export default useProductSizeGuide
